"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ShadePicker = require("./ShadePicker");
Object.keys(_ShadePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ShadePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShadePicker[key];
    }
  });
});
